<template lang="pug">
  .registration
      .registration__container.container
          .registration__title
              span(v-html="tr.registration.title")

          vButton.registration__btn(:href="urlToPartner()" target="_blank" xLarge white)
</template>

<script>
import vButton from '../../elements/vButton'
import EditableBlock from '../EditableBlock'
import url from '@/mixins/getPartnerUrl'

export default {
  components: {
    vButton,
    EditableBlock
  },
  data () {
    return {
      section: 'main'
    }
  },
  mixins: [url]
}
</script>

<style lang="scss">
  .registration {
    position: relative;
    z-index: 2;

    padding-top: 147px!important;
    padding-bottom: 158px!important;

    background: $main_color;

    @media(max-width: 1024px){
      padding-top: 100px!important;
      padding-bottom: 100px!important;
    }

    @media(max-width: 480px){
      padding-top: 50px!important;
      padding-bottom: 50px!important;
    }

    &__container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 1024px) {
        flex-direction: column;
        align-items: flex-start;
      }
      @media (max-width: 480px) {
        align-items: inherit;
      }
    }

    &__title {

      font-size: 40px;
      color: $second_color;
      line-height: 1.25;
      letter-spacing: 0.4px;

      @media (max-width: 1024px) {
        margin-bottom: 20px;
        font-size: 34px;
      }
    }

    &__btn {
      color: black;
      text-align: center;
      font-size: 28px;
      background-color: #fff;
      line-height: 2;
      text-decoration: none;
      white-space: nowrap;
      @media(max-width: 480px){
        display: inline-block;
        line-height: 1;
        padding: 20px 40px;
        font-size: 24px;
      }
    }
  }
</style>
